import { render, staticRenderFns } from "./developAdvertisingData.vue?vue&type=template&id=8f52a764&scoped=true&"
import script from "./developAdvertisingData.vue?vue&type=script&lang=js&"
export * from "./developAdvertisingData.vue?vue&type=script&lang=js&"
import style0 from "./developAdvertisingData.vue?vue&type=style&index=0&id=8f52a764&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f52a764",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f52a764')) {
      api.createRecord('8f52a764', component.options)
    } else {
      api.reload('8f52a764', component.options)
    }
    module.hot.accept("./developAdvertisingData.vue?vue&type=template&id=8f52a764&scoped=true&", function () {
      api.rerender('8f52a764', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/developAdvertisingData.vue"
export default component.exports